<template>
  <section
    v-if="company.company_key === 'keystonepmc'"
    class="property-section tw-relative !tw-justify-end tw-pb-10 tw-pt-36 lg:tw-flex lg:tw-pt-52 2xl:tw-pb-20"
  >
    <div class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-overflow-hidden tw-bg-cover tw-bg-center">
      <BlockSymbol
        :position-text="String(vars?.blockPositionText || 'left_bottom')"
        :block-color="String(vars?.blockColor || 'block_secondary')"
        :block-symbol="String(vars?.blockSymbolText || '')"
        :block-opacity="Number(vars?.blockOpacityNumber || 1)"
        :image-class="`tw-max-w-full lg:tw-max-w-[45%]`"
        :block-logo-image="
          String(vars?.blockLogoImage || 'https://files.keystonepmc.neuronwebsites.co.uk/block-symbol-2-ecjssr8qm.png')
        "
      />
    </div>
    <div class="container tw-z-10 tw-col-span-12 tw-w-full tw-max-w-[1440px] tw-pb-3 lg:tw-block">
      <div class="tw-col-span-12 tw-w-full tw-pb-3 lg:tw-flex lg:tw-flex-col lg:tw-gap-y-12">
        <div class="custom-search-section tw-hidden lg:tw-block">
          <lazy-library-properties-search-box
            v-model:filters="filters"
            v-model:locations="locations"
            v-model:search-input="searchInput"
            :search-type="searchType"
            @on-search="onSearch()"
            @open-extended-popup="openExtendedPopup()"
            :agent-type="vars.agentType || null"
            version="v8"
            :buy="vars.buyBool"
            :rent="vars.rentBool"
            title=""
            :icon-only="vars.searchIconBool"
            :alternative-layout="true"
          />
        </div>

        <div class="tw-block lg:tw-hidden">
          <lazy-library-properties-search-box
            v-model:filters="filters"
            v-model:locations="locations"
            v-model:search-input="searchInput"
            :search-type="searchType"
            @on-search="onSearch()"
            @open-extended-popup="openExtendedPopup()"
            :buy="vars.buyBool"
            :rent="vars.rentBool"
            version="v9"
            title=""
            :icon-only="false"
            :alternative-layout="true"
          />
        </div>

        <template v-if="sidebarComponents && sidebarComponents.length === 0">
          <div
            class="tw-col-span-12 tw-mt-12 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-between tw-gap-4 tw-py-4 md:tw-flex-row"
          >
            <h5 class="tw-w-full tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div v-if="isApplicantExist" class="tw-flex tw-w-full tw-items-center tw-gap-4">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                <p class="tw-mr-2 tw-truncate tw-capitalize !tw-text-white">
                  {{ contactSession.name }}
                </p>
              </div>
              <button
                v-if="isApplicantExist && !vars.customButtonLabelText"
                class="n-primary tw-w-full md:tw-w-auto"
                @click="updateHeadsUpAlerts()"
              >
                Update Heads Up Alert
              </button>
              <button
                v-if="isApplicantExist && vars.customButtonLabelText"
                class="n-primary tw-w-full md:tw-w-auto"
                @click="updateHeadsUpAlerts()"
              >
                Update {{ vars.customButtonLabelText }} Alert
              </button>
            </div>
            <button
              v-if="!isApplicantExist"
              class="tw-w-full md:tw-w-auto"
              :class="company.company_key === 'keystonepmc' ? 'n-secondary' : 'n-quaternary'"
              @click="setupHeadsUpAlerts()"
            >
              REGISTER FOR ALERTS
            </button>
          </div>
        </template>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
            <h5 class="tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div class="tw-flex tw-items-center tw-gap-6">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 nc-icon tw-me-2" style="font-size: 24px"> </span>
                <p class="contact-session-name tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button v-if="!isApplicantExist" class="n-quaternary" @click="setupHeadsUpAlerts()">
                REGISTER FOR ALERTS
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>

  <section
    v-else-if="company.company_key === 'kineticestateagents'"
    class="property-section tw-relative tw-hidden !tw-justify-end tw-px-16 tw-pb-10 tw-pt-52 lg:tw-flex 2xl:tw-pb-20"
  >
    <div class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-overflow-hidden tw-bg-cover tw-bg-center">
      <BlockSymbol
        v-if="company.company_key === 'copeandco'"
        position-text="left_bottom"
        block-color="block_secondary"
        :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      />
    </div>
    <div class="tw-z-10 tw-col-span-12 tw-hidden tw-w-full tw-max-w-[1440px] tw-pb-3 lg:tw-block">
      <div class="tw-col-span-12 tw-hidden tw-w-full tw-pb-3 lg:tw-flex lg:tw-flex-col lg:tw-gap-y-12">
        <div class="custom-search-section tw-hidden lg:tw-block">
          <lazy-library-properties-search-box
            v-model:filters="filters"
            v-model:locations="locations"
            v-model:search-input="searchInput"
            :search-type="searchType"
            @on-search="onSearch()"
            @open-extended-popup="openExtendedPopup()"
            :agent-type="vars.agentType || null"
            version="v10"
            :buy="vars.buyBool"
            :rent="vars.rentBool"
            title=""
            :icon-only="vars.searchIconBool"
            :alternative-layout="true"
          />
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length === 0">
          <div class="tw-col-span-12 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
            <h5 class="tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                <p class="tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button
                v-if="isApplicantExist && !vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update Heads Up Alert
              </button>
              <button
                v-if="isApplicantExist && vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update {{ vars.customButtonLabelText }} Alert
              </button>
            </div>
            <button v-if="!isApplicantExist" class="n-primary" @click="setupHeadsUpAlerts()">
              Be the first to find out
            </button>
          </div>
        </template>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
            <h5 class="tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div class="tw-flex tw-items-center tw-gap-6">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 nc-icon tw-me-2" style="font-size: 24px"> </span>
                <p class="contact-session-name tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button v-if="!isApplicantExist" class="n-quaternary" @click="setupHeadsUpAlerts()">
                Be the first to find out
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>

  <section
    v-else
    class="property-section tw-relative tw-hidden !tw-justify-end tw-px-16 tw-pb-10 tw-pt-52 lg:tw-flex 2xl:tw-pb-20"
  >
    <div class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-overflow-hidden tw-bg-cover tw-bg-center">
      <BlockSymbol
        v-if="company.company_key === 'copeandco'"
        position-text="left_bottom"
        block-color="block_secondary"
        block-symbol="&"
        :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      />
    </div>
    <div class="tw-z-10 tw-col-span-12 tw-hidden tw-w-full tw-max-w-[1440px] tw-pb-3 lg:tw-block">
      <div class="tw-col-span-12 tw-hidden tw-w-full tw-pb-3 lg:tw-flex lg:tw-flex-col lg:tw-gap-y-12">
        <div class="custom-search-section tw-hidden lg:tw-block">
          <lazy-library-properties-search-box
            v-model:filters="filters"
            v-model:locations="locations"
            v-model:search-input="searchInput"
            :search-type="searchType"
            @on-search="onSearch()"
            @open-extended-popup="openExtendedPopup()"
            :agent-type="vars.agentType || null"
            :version="company.company_key === 'keystonepmc' ? 'v8' : 'v4'"
            :buy="vars.buyBool"
            :rent="vars.rentBool"
            title=""
            :icon-only="vars.searchIconBool"
            :alternative-layout="true"
          />
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length === 0">
          <div class="tw-col-span-12 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
            <h5 class="tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                <p class="tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button
                v-if="isApplicantExist && !vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update Heads Up Alert
              </button>
              <button
                v-if="isApplicantExist && vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update {{ vars.customButtonLabelText }} Alert
              </button>
            </div>
            <button
              v-if="!isApplicantExist"
              :class="company.company_key === 'keystonepmc' ? 'n-primary' : 'n-quaternary'"
              @click="setupHeadsUpAlerts()"
            >
              REGISTER FOR ALERTS
            </button>
          </div>
        </template>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
            <h5 class="tw-uppercase !tw-text-white">{{ filterSummary }}</h5>
            <div class="tw-flex tw-items-center tw-gap-6">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 nc-icon tw-me-2" style="font-size: 24px"> </span>
                <p class="contact-session-name tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button v-if="!isApplicantExist" class="n-quaternary" @click="setupHeadsUpAlerts()">
                REGISTER FOR ALERTS
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>

  <Properties :component="component">
    <template #library-properties>
      <div
        v-if="company.company_key === 'keystonepmc'"
        class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6 tw-pt-16 md:tw-pt-24 lg:tw-pt-20"
        :style="vars.backgroundColor ? `background-color: var(--c-${vars.backgroundColor})` : ''"
      >
        <div
          v-if="isExtendedFilterPopupVisible && !isMobile"
          class="tw-fixed tw-left-0 tw-top-0 tw-z-20 tw-h-screen tw-w-full tw-bg-black tw-opacity-40"
        ></div>
        <!-- Mobile layout for results section -->
        <div class="tw-col-span-12 tw-w-full tw-pb-3">
          <!-- Mobile layout (stacked vertically) -->
          <div class="tw-flex tw-flex-col tw-gap-4 md:tw-hidden">
            <h3 v-if="highlightedProperties.length === 0" class="tw-mb-4 tw-text-start">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h3>
            <h3 v-else-if="highlightedProperties.length > 0 && properties.length" class="tw-text-center">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h3>
            <div class="tw-flex tw-w-full tw-justify-start">
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
                class="tw-w-full"
              />
            </div>
          </div>
          <!-- Desktop layout (horizontal) -->
          <div class="properties-match-card tw-hidden tw-items-center tw-justify-between md:tw-flex">
            <h3 v-if="highlightedProperties.length === 0">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h3>
            <h3 v-else-if="highlightedProperties.length > 0 && properties.length">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h3>
            <div class="tw-flex tw-items-center tw-gap-4">
              <button v-if="isApplicantExist" class="n-primary" @click="updateHeadsUpAlerts()">UPDATE ALERTS</button>
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
              />
            </div>
          </div>
        </div>
        <div
          class="tw-col-span-12"
          :class="{
            'tw-order-1 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length,
          }"
        >
          <div v-if="filterSummary">
            <div class="tw-py-5" v-if="isLoading">
              <loader />
            </div>
            <div v-else-if="!isLoading && (highlightedProperties.length || properties.length)">
              <div v-if="locations.length > 0" class="row g-0 mb-3">
                <div class="col-12">
                  <location-boxes v-model:locations="locations" :is-first-location-excluded="true" />
                </div>
              </div>
              <template v-if="highlightedProperties.length">
                <div
                  v-if="highlightedProperties.length > 0"
                  class="row g-0 mb-5 d-flex flex-row justify-content-between"
                >
                  <div class="col-md-8 col-12 tw-mb-4 md:tw-mb-0">
                    <lazy-library-title tag="h1" :text="`New matches: ${newMatchesPropertyCount} properties`">
                    </lazy-library-title>
                  </div>
                  <div class="col-md-4 col-xl-2 col-12 d-flex justify-content-end">
                    <lazy-library-properties-sort-box v-model:filter-criteria="filterCriteria" @on-sort="sort()" />
                  </div>
                </div>
                <lazy-library-properties-page-list
                  v-if="highlightedProperties.length > 0"
                  :component="component"
                  :properties="highlightedProperties"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </template>
              <lazy-library-properties-page-list
                :theme="theme"
                :component="component"
                :properties="properties"
                :columns="vars.columnsNumber"
                :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
                :version="vars.propertyListItemVersionText"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
              <div v-if="isPropertiesGridLoadMoreActive" class="tw-flex tw-items-center tw-justify-center tw-py-8">
                <button
                  class="n-secondary load-more-button"
                  :style="{
                    backgroundColor:
                      vars.searchTypeText === 'lettings'
                        ? 'var(--c-tertiary) !important'
                        : vars.searchTypeText === 'sales'
                          ? 'var(--c-secondary) !important'
                          : '',
                  }"
                  @click="loadMore()"
                >
                  LOAD MORE
                </button>
              </div>
            </div>
            <div v-else-if="properties && properties.length === 0" class="tw-h-[40vh] tw-py-5">
              <lazy-theme4-base-not-found title="Unfortunately, there are no properties matching your search criteria.">
                <template #description>
                  Please
                  <nuxt-link to="/heads-up-alerts/register" :external="true" class="n-link"
                    ><u class="unknown-user-text text">setup a Heads Up property alert</u></nuxt-link
                  >
                  to be kept up to date in the future with new suggested properties that are based around your specific
                  criteria.
                </template>
              </lazy-theme4-base-not-found>
            </div>
            <advanced-search
              v-if="!isMobile && isExtendedFilterPopupVisible"
              v-model:filters="filters"
              v-model:is-available="searchInput.is_available"
              :search-type="searchType"
              @on-open-all-styles-popup="allStylesConfig.isActive = true"
              @close-advanced-filter="closeAdvancedFilter()"
              :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
              :component="component"
              @open-extended-popup="turnOffExtendedPopup()"
            />
            <popup
              v-if="isMobile"
              :config="advancedSearchConfig"
              custom-width="auto"
              :custom-wrapper-class="propertiesConfig.advancedSearchMobilePopupBackgroundClass"
            >
              <template #content>
                <advanced-search
                  v-if="isExtendedFilterPopupVisible"
                  v-model:filters="filters"
                  v-model:is-available="searchInput.is_available"
                  :search-type="searchType"
                  @on-open-all-styles-popup="allStylesConfig.isActive = true"
                  @on-searched="onSearch()"
                  @close-advanced-filter="closeAdvancedFilter()"
                  :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
                />
              </template>
            </popup>
            <popup v-if="allStylesConfig.isActive" v-model:config="allStylesConfig">
              <template #content>
                <all-property-types-styles
                  v-model:selected-type-styles="filters.property_types"
                  @close="allStylesConfig.isActive = false"
                  variant="v2"
                />
              </template>
            </popup>
            <popup
              v-if="applicantProfilesPopupConfig.isActive"
              v-model:config="applicantProfilesPopupConfig"
              custom-width="500px"
              class="applicant-profile-popup"
            >
              <template #content>
                <applicant-profiles
                  :search-type="searchType"
                  @on-selected-new-applicant="onSelectedNewApplicant()"
                  :is-visible-update-button="vars.applicantProfilesUpdateButtonBool"
                />
              </template>
            </popup>
          </div>
        </div>
        <div
          v-if="sidebarComponents && sidebarComponents.length"
          class="tw-order-2 tw-col-span-12 tw-flex tw-h-full tw-w-full xl:tw-col-span-4"
        >
          <!-- Add sticky wrapper -->
          <div class="sidebar-sticky-wrapper tw-mb-8 tw-w-full">
            <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-4 tw-pb-12">
              <theme7-available-components-for-sidebar
                key="property-sidebar"
                key-prefix="property-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="company.company_key === 'kineticestateagents'"
        class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6 tw-pt-36 md:tw-pt-52 lg:tw-pt-20"
        :style="vars.backgroundColor ? `background-color: var(--c-${vars.backgroundColor})` : ''"
      >
        <div
          v-if="isExtendedFilterPopupVisible && !isMobile"
          class="tw-fixed tw-left-0 tw-top-0 tw-z-20 tw-h-screen tw-w-full tw-bg-black tw-opacity-40"
        ></div>
        <div class="tw-col-span-12 tw-w-full tw-pb-3 lg:tw-hidden">
          <div class="tw-block lg:tw-hidden">
            <lazy-library-properties-search-box
              v-model:filters="filters"
              v-model:locations="locations"
              v-model:search-input="searchInput"
              :search-type="searchType"
              @on-search="onSearch()"
              @open-extended-popup="openExtendedPopup()"
              :buy="vars.buyBool"
              :rent="vars.rentBool"
              version="v11"
              title=""
              :icon-only="false"
              :alternative-layout="true"
            />
          </div>
          <template v-if="sidebarComponents && sidebarComponents.length">
            <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
              <h5>{{ filterSummary }}</h5>
              <div class="tw-flex tw-items-center tw-gap-6">
                <div
                  v-if="isApplicantExist"
                  class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                  @click="onClickedProfile()"
                >
                  <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                  <p class="tw-mr-2 tw-truncate tw-capitalize">
                    {{ contactSession.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="tw-py-4"></div>
          </template>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length === 0">
          <div class="tw-col-span-12 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4 lg:tw-hidden">
            <h5>{{ filterSummary }}</h5>
            <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                <p class="tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button
                v-if="isApplicantExist && !vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update Heads Up Alert
              </button>
              <button
                v-if="isApplicantExist && vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update {{ vars.customButtonLabelText }} Alert
              </button>
            </div>
          </div>
        </template>
        <!-- Mobile layout for results section -->
        <div class="tw-col-span-12 tw-w-full tw-pb-3">
          <!-- Mobile layout (stacked vertically) -->
          <div class="tw-flex tw-flex-col tw-gap-4 md:tw-hidden">
            <h3 v-if="highlightedProperties.length === 0" class="tw-mb-4 tw-text-start">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-primary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h3>
            <h2 v-else-if="highlightedProperties.length > 0 && properties.length" class="tw-text-center">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-primary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h2>
            <div class="tw-flex tw-h-[60px] tw-justify-center">
              <button v-if="isApplicantExist" class="n-primary tw-w-full" @click="updateHeadsUpAlerts()">
                UPDATE ALERTS
              </button>
            </div>
            <div class="tw-flex tw-justify-start">
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
                class="tw-w-full"
              />
            </div>
          </div>
          <!-- Desktop layout (horizontal) -->
          <div class="properties-match-card tw-hidden tw-items-center tw-justify-between md:tw-flex">
            <h2 v-if="highlightedProperties.length === 0">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-primary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h2>
            <h2 v-else-if="highlightedProperties.length > 0 && properties.length">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h2>
            <div class="tw-flex tw-items-center tw-gap-4">
              <button v-if="isApplicantExist" class="n-primary" @click="updateHeadsUpAlerts()">UPDATE ALERTS</button>
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
              />
            </div>
          </div>
        </div>
        <div
          class="tw-col-span-12"
          :class="{
            'tw-order-1 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length,
          }"
        >
          <div v-if="filterSummary">
            <div class="tw-py-5" v-if="isLoading">
              <loader />
            </div>
            <div v-else-if="!isLoading && (highlightedProperties.length || properties.length)">
              <div v-if="locations.length > 0" class="row g-0 mb-3">
                <div class="col-12">
                  <location-boxes v-model:locations="locations" :is-first-location-excluded="true" />
                </div>
              </div>
              <template v-if="highlightedProperties.length">
                <div
                  v-if="highlightedProperties.length > 0"
                  class="row g-0 mb-5 d-flex flex-row justify-content-between"
                >
                  <div class="col-md-8 col-12 tw-mb-4 md:tw-mb-0">
                    <lazy-library-title tag="h1" :text="`New matches: ${newMatchesPropertyCount} properties`">
                    </lazy-library-title>
                  </div>
                  <div class="col-md-4 col-xl-2 col-12 d-flex justify-content-end">
                    <lazy-library-properties-sort-box v-model:filter-criteria="filterCriteria" @on-sort="sort()" />
                  </div>
                </div>
                <lazy-library-properties-page-list
                  v-if="highlightedProperties.length > 0"
                  :component="component"
                  :properties="highlightedProperties"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </template>
              <lazy-library-properties-page-list
                :theme="theme"
                :component="component"
                :properties="properties"
                :columns="vars.columnsNumber"
                :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
                :version="vars.propertyListItemVersionText"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
              <div v-if="isPropertiesGridLoadMoreActive" class="tw-flex tw-items-center tw-justify-center tw-py-8">
                <button class="n-primary load-more-button" @click="loadMore()">LOAD MORE</button>
              </div>
            </div>
            <div v-else-if="properties && properties.length === 0" class="tw-h-[40vh] tw-py-5">
              <lazy-theme4-base-not-found title="Unfortunately, there are no properties matching your search criteria.">
                <template #description>
                  Please
                  <nuxt-link to="/heads-up-alerts/register" :external="true" class="n-link"
                    ><u class="unknown-user-text text">setup a Heads Up property alert</u></nuxt-link
                  >
                  to be kept up to date in the future with new suggested properties that are based around your specific
                  criteria.
                </template>
              </lazy-theme4-base-not-found>
            </div>
            <advanced-search
              v-if="!isMobile && isExtendedFilterPopupVisible"
              v-model:filters="filters"
              v-model:is-available="searchInput.is_available"
              :search-type="searchType"
              @on-open-all-styles-popup="allStylesConfig.isActive = true"
              @close-advanced-filter="closeAdvancedFilter()"
              :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
              :component="component"
              @open-extended-popup="turnOffExtendedPopup()"
            />
            <popup
              v-if="isMobile"
              :config="advancedSearchConfig"
              custom-width="auto"
              :custom-wrapper-class="propertiesConfig.advancedSearchMobilePopupBackgroundClass"
            >
              <template #content>
                <advanced-search
                  v-if="isExtendedFilterPopupVisible"
                  v-model:filters="filters"
                  v-model:is-available="searchInput.is_available"
                  :search-type="searchType"
                  @on-open-all-styles-popup="allStylesConfig.isActive = true"
                  @on-searched="onSearch()"
                  @close-advanced-filter="closeAdvancedFilter()"
                  :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
                />
              </template>
            </popup>
            <popup v-if="allStylesConfig.isActive" v-model:config="allStylesConfig">
              <template #content>
                <all-property-types-styles
                  v-model:selected-type-styles="filters.property_types"
                  @close="allStylesConfig.isActive = false"
                  variant="v2"
                />
              </template>
            </popup>
            <popup
              v-if="applicantProfilesPopupConfig.isActive"
              v-model:config="applicantProfilesPopupConfig"
              custom-width="500px"
              class="applicant-profile-popup"
            >
              <template #content>
                <applicant-profiles
                  :search-type="searchType"
                  @on-selected-new-applicant="onSelectedNewApplicant()"
                  :is-visible-update-button="vars.applicantProfilesUpdateButtonBool"
                />
              </template>
            </popup>
          </div>
        </div>
        <div
          v-if="sidebarComponents && sidebarComponents.length"
          class="tw-order-2 tw-col-span-12 tw-flex tw-h-full tw-w-full xl:tw-col-span-4"
        >
          <!-- Add sticky wrapper -->
          <div class="sidebar-sticky-wrapper tw-mb-8 tw-w-full">
            <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-4 tw-pb-12">
              <theme7-available-components-for-sidebar
                key="property-sidebar"
                key-prefix="property-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6 tw-pt-36 md:tw-pt-52 lg:tw-pt-20"
        :style="vars.backgroundColor ? `background-color: var(--c-${vars.backgroundColor})` : ''"
      >
        <div
          v-if="isExtendedFilterPopupVisible && !isMobile"
          class="tw-fixed tw-left-0 tw-top-0 tw-z-20 tw-h-screen tw-w-full tw-bg-black tw-opacity-40"
        ></div>
        <div class="tw-col-span-12 tw-w-full tw-pb-3 lg:tw-hidden">
          <div class="tw-block lg:tw-hidden">
            <lazy-library-properties-search-box
              v-model:filters="filters"
              v-model:locations="locations"
              v-model:search-input="searchInput"
              :search-type="searchType"
              @on-search="onSearch()"
              @open-extended-popup="openExtendedPopup()"
              :buy="vars.buyBool"
              :rent="vars.rentBool"
              version="v2"
              title=""
              :icon-only="false"
              :alternative-layout="true"
            />
          </div>
          <template v-if="sidebarComponents && sidebarComponents.length">
            <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
              <h5>{{ filterSummary }}</h5>
              <div class="tw-flex tw-items-center tw-gap-6">
                <div
                  v-if="isApplicantExist"
                  class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                  @click="onClickedProfile()"
                >
                  <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                  <p class="tw-mr-2 tw-truncate tw-capitalize">
                    {{ contactSession.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="tw-py-4"></div>
          </template>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length === 0">
          <div class="tw-col-span-12 tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4 lg:tw-hidden">
            <h5>{{ filterSummary }}</h5>
            <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
              <div
                v-if="isApplicantExist"
                class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                @click="onClickedProfile()"
              >
                <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                <p class="tw-mr-2 tw-truncate tw-capitalize">
                  {{ contactSession.name }}
                </p>
              </div>
              <button
                v-if="isApplicantExist && !vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update Heads Up Alert
              </button>
              <button
                v-if="isApplicantExist && vars.customButtonLabelText"
                class="n-primary"
                @click="updateHeadsUpAlerts()"
              >
                Update {{ vars.customButtonLabelText }} Alert
              </button>
            </div>
          </div>
        </template>
        <!-- Mobile layout for results section -->
        <div class="tw-col-span-12 tw-w-full tw-pb-3">
          <!-- Mobile layout (stacked vertically) -->
          <div class="tw-flex tw-flex-col tw-gap-4 md:tw-hidden">
            <h3 v-if="highlightedProperties.length === 0" class="tw-mb-4 tw-text-start">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h3>
            <h3 v-else-if="highlightedProperties.length > 0 && properties.length" class="tw-text-center">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h3>
            <div class="tw-flex tw-h-[60px] tw-justify-center">
              <button v-if="!isApplicantExist" class="n-primary tw-w-full" @click="setupHeadsUpAlerts()">
                REGISTER FOR ALERTS
              </button>
              <button v-if="isApplicantExist" class="n-primary tw-w-full" @click="updateHeadsUpAlerts()">
                UPDATE ALERTS
              </button>
            </div>
            <div class="tw-flex tw-justify-start">
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
                class="tw-w-full"
              />
            </div>
          </div>
          <!-- Desktop layout (horizontal) -->
          <div class="properties-match-card tw-hidden tw-items-center tw-justify-between md:tw-flex">
            <h3 v-if="highlightedProperties.length === 0">
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }}</span
              >
              RESULTS
            </h3>
            <h3 v-else-if="highlightedProperties.length > 0 && properties.length">
              Existing matches:
              <span
                :style="
                  vars.searchTypeText === 'sales'
                    ? 'color: var(--c-secondary)'
                    : vars.searchTypeText === 'lettings'
                      ? 'color: var(--c-tertiary)'
                      : ''
                "
                >{{ count }} - {{ highlightedProperties.length }}</span
              >
              RESULTS
            </h3>
            <div class="tw-flex tw-items-center tw-gap-4">
              <button v-if="!isApplicantExist" class="n-primary" @click="setupHeadsUpAlerts()">
                REGISTER FOR ALERTS
              </button>
              <button v-if="isApplicantExist" class="n-primary" @click="updateHeadsUpAlerts()">UPDATE ALERTS</button>
              <library-properties-sort-box
                v-if="highlightedProperties.length === 0"
                v-model:filter-criteria="filterCriteria"
                version="v2"
                @on-sort="sort()"
              />
            </div>
          </div>
        </div>
        <div
          class="tw-col-span-12"
          :class="{
            'tw-order-1 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length,
          }"
        >
          <div v-if="filterSummary">
            <div class="tw-py-5" v-if="isLoading">
              <loader />
            </div>
            <div v-else-if="!isLoading && (highlightedProperties.length || properties.length)">
              <div v-if="locations.length > 0" class="row g-0 mb-3">
                <div class="col-12">
                  <location-boxes v-model:locations="locations" :is-first-location-excluded="true" />
                </div>
              </div>
              <template v-if="highlightedProperties.length">
                <div
                  v-if="highlightedProperties.length > 0"
                  class="row g-0 mb-5 d-flex flex-row justify-content-between"
                >
                  <div class="col-md-8 col-12 tw-mb-4 md:tw-mb-0">
                    <lazy-library-title tag="h1" :text="`New matches: ${newMatchesPropertyCount} properties`">
                    </lazy-library-title>
                  </div>
                  <div class="col-md-4 col-xl-2 col-12 d-flex justify-content-end">
                    <lazy-library-properties-sort-box v-model:filter-criteria="filterCriteria" @on-sort="sort()" />
                  </div>
                </div>
                <lazy-library-properties-page-list
                  v-if="highlightedProperties.length > 0"
                  :component="component"
                  :properties="highlightedProperties"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </template>
              <lazy-library-properties-page-list
                :theme="theme"
                :component="component"
                :properties="properties"
                :columns="vars.columnsNumber"
                :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
                :version="vars.propertyListItemVersionText"
                :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              />
              <div v-if="isPropertiesGridLoadMoreActive" class="tw-flex tw-items-center tw-justify-center tw-py-8">
                <button
                  class="n-secondary load-more-button"
                  :style="{
                    backgroundColor:
                      vars.searchTypeText === 'lettings'
                        ? 'var(--c-tertiary) !important'
                        : vars.searchTypeText === 'sales'
                          ? 'var(--c-secondary) !important'
                          : '',
                  }"
                  @click="loadMore()"
                >
                  LOAD MORE
                </button>
              </div>
            </div>
            <div v-else-if="properties && properties.length === 0" class="tw-h-[40vh] tw-py-5">
              <lazy-theme4-base-not-found title="Unfortunately, there are no properties matching your search criteria.">
                <template #description>
                  Please
                  <nuxt-link to="/heads-up-alerts/register" :external="true" class="n-link"
                    ><u class="unknown-user-text text">setup a Heads Up property alert</u></nuxt-link
                  >
                  to be kept up to date in the future with new suggested properties that are based around your specific
                  criteria.
                </template>
              </lazy-theme4-base-not-found>
            </div>
            <advanced-search
              v-if="!isMobile && isExtendedFilterPopupVisible"
              v-model:filters="filters"
              v-model:is-available="searchInput.is_available"
              :search-type="searchType"
              @on-open-all-styles-popup="allStylesConfig.isActive = true"
              @close-advanced-filter="closeAdvancedFilter()"
              :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
              :component="component"
              @open-extended-popup="turnOffExtendedPopup()"
            />
            <popup
              v-if="isMobile"
              :config="advancedSearchConfig"
              custom-width="auto"
              :custom-wrapper-class="propertiesConfig.advancedSearchMobilePopupBackgroundClass"
            >
              <template #content>
                <advanced-search
                  v-if="isExtendedFilterPopupVisible"
                  v-model:filters="filters"
                  v-model:is-available="searchInput.is_available"
                  :search-type="searchType"
                  @on-open-all-styles-popup="allStylesConfig.isActive = true"
                  @on-searched="onSearch()"
                  @close-advanced-filter="closeAdvancedFilter()"
                  :theme="company.company_key === 'keystonepmc' ? 'theme7' : 'theme4'"
                />
              </template>
            </popup>
            <popup v-if="allStylesConfig.isActive" v-model:config="allStylesConfig">
              <template #content>
                <all-property-types-styles
                  v-model:selected-type-styles="filters.property_types"
                  @close="allStylesConfig.isActive = false"
                  variant="v2"
                />
              </template>
            </popup>
            <popup
              v-if="applicantProfilesPopupConfig.isActive"
              v-model:config="applicantProfilesPopupConfig"
              custom-width="500px"
              class="applicant-profile-popup"
            >
              <template #content>
                <applicant-profiles
                  :search-type="searchType"
                  @on-selected-new-applicant="onSelectedNewApplicant()"
                  :is-visible-update-button="vars.applicantProfilesUpdateButtonBool"
                />
              </template>
            </popup>
          </div>
        </div>
        <div
          v-if="sidebarComponents && sidebarComponents.length"
          class="tw-order-2 tw-col-span-12 tw-flex tw-h-full tw-w-full xl:tw-col-span-4"
        >
          <!-- Add sticky wrapper -->
          <div class="sidebar-sticky-wrapper tw-mb-8 tw-w-full">
            <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-4 tw-pb-12">
              <theme7-available-components-for-sidebar
                key="property-sidebar"
                key-prefix="property-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Properties>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import Properties from '~/components/library/Properties.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'Theme7Properties',

  mixins: [ComponentMixin],

  extends: Properties,

  components: {
    Properties,
    BlockSymbol,
  },

  mounted() {
    this.fixMainOverflow();
  },

  methods: {
    fixMainOverflow() {
      // Target the main element directly
      const mainElement = document.querySelector('main');
      if (mainElement) {
        // Store original value for cleanup
        this.originalMainOverflow = mainElement.style.overflow || window.getComputedStyle(mainElement).overflow;

        mainElement.style.overflow = 'visible';
        mainElement.style.setProperty('overflow', 'visible', 'important');
      }

      // Also check other potential containers
      const containers = document.querySelectorAll('.container, .main-container, .app-container');
      containers.forEach((container) => {
        container.style.setProperty('overflow', 'visible', 'important');
      });
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['company']),
  },

  beforeUnmount() {
    // Restore original overflow if needed
    const mainElement = document.querySelector('main');
    if (mainElement && this.originalMainOverflow) {
      mainElement.style.overflow = this.originalMainOverflow;
    }
  },
});
</script>

<style scoped>
.block {
  font-size: 40em !important;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -80px !important;
  left: -90px !important;
}

.sidebar-sticky-wrapper {
  position: sticky;
  top: 9rem; /* Adjust based on your header height */
  height: fit-content;
  overflow-y: scroll !important;
  overflow-x: hidden;
  align-self: flex-start;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: var(--c-primary) transparent; /* Firefox */
}

/* Webkit browsers (Chrome, Safari, Edge) */
.sidebar-sticky-wrapper::-webkit-scrollbar {
  width: 6px;
}

.sidebar-sticky-wrapper::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.sidebar-sticky-wrapper::-webkit-scrollbar-thumb {
  background: var(--c-primary);
  border-radius: 4px;
  border: 1px solid transparent;
  background-clip: content-box;
}

.sidebar-sticky-wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--c-primary);
  background-clip: content-box;
}

/* Disable sticky on mobile */
@media (max-width: 1279px) {
  .sidebar-sticky-wrapper {
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}

.contact-session-name,
.nc-icon {
  color: var(--c-text_primary) !important;
}
</style>
